import { Subject } from 'rxjs'

export enum CrudAction {
  UPSERT,
  DELETE,
}

export interface CrudEvent<T, T2 = string> {
  action: CrudAction
  entity?: T
  entityId: T2
}

export class CrudSubject<T, T2 = string> extends Subject<CrudEvent<T, T2>> {
  upsert(entity: T, entityId: T2) {
    this.next({
      action: CrudAction.UPSERT,
      entity: entity,
      entityId: entityId,
    })
  }

  delete(entityId: T2) {
    this.next({
      action: CrudAction.DELETE,
      entityId: entityId,
    })
  }
}
